'use strict';
(function($){
	/*
	 * Vetology.AutoComplete widget
	 *
	 * @description Helper class to add autocomplete to fields
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.AutoComplete',
		{
			"options": {
				"fields": [
					{
						"alias": "breed",
						"target": '[name="Breed"]',
                        "function": "_findBreed",
						"delay": 500,
                        "minlength": 3
                    },
					{
						"alias": "patients",
						"target": '[name="ClinicPatientID"]',
						"function": "findPatients",
						"delay": 500,
                        "minlength": 4
					},
					{
						"alias": "conditions",
						"target": '[name="tentative_diagnosys"]',
						"function": "_findConditions",
						"delay": 500,
                        "minlength": 3
					},
					{
						"alias": "object_id",
						"target": '.object_id_finder',
						"function": "_findObjectsByLabel",
						"delay": 500,
                        "minlength": 4,
						"method": {
							type: "keyup",
							name: "_findObjectsByLabel"
						}
					},
					{
						"alias": "object",
						"target": '.objectFinder',
						"function": "_findObjects",
						"delay": 500,
                        "minlength": 1,
						"method": {
							type: "change",
							name: "_objectSearch"
						}
					}
				],
				"timeOuts": {},
				"dataSets": {
					'patients': {}
				},
				"searches": []
			},
			/*
			 * Vetology.AutoComplete._init
			 *
			 * @description	Initializes the New Case helper
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._initEvents();
			},
			/*
			 * Vetology.AutoComplete._initEvents
			 *
			 * @description	Initializes the events on all fields foudn in the DOM
			 *
			 * @return NULL
			 *
			 */
			"_initEvents": function(){
				var o = this;
				$("body").on("click", ".remove_tag", function(){
					o._removeTag($(this));
				});
				$("body").on("click", ".typeahead a", function(){
					var el = $(this);
					if(el.hasClass("close_typeahead")){
						o._blur(el);
					} else {
						var p = el.closest("div").find(".typeahead_input");
						o._typeahead(el, p);
						o._blur(el);
					}
				});
				$.each(o.options.fields, function(i,t){
					o.options.timeOuts[t.alias] = null;
                    o.options.timeOuts['min-characters-for-autocomplete'] = null;
					if(typeof t.method != "undefined"){
						$("body").on(t.method.type, t.target, function(){
							var el = $(this);
							if(typeof t.delay != "undefined"){
							    if (el.closest('.objectFinder_block').length == 0) {
							        // clear timeouts if not part of an objectFinder block
                                    clearTimeout(o.options.timeOuts[t.alias]);
                                    o._clearMinlengthRequirement(el);
                                }
								o.options.timeOuts[t.alias] = setTimeout(
									function(){
                                        const val = el.val();
                                        if (typeof val !== 'string') {
                                            return;
                                        }
                                        if (!o._checkForMinChars(el, t)) {
                                            return;
                                        }
                                        o[t.method.name](i,t, el);
									},
									t.delay
								);
							} else {
								o[t.method.name](i,t, el);
							}
						});
					} else {
						$("body").on("keyup", t.target, function(){
							o._keyup(i,t, $(this));
						});
					}
				});
			},
            "_checkForMinChars": function(el, t) {
                const o = this;
                const val = el.val();
                if (val.length < t.minlength) {
                    o.options.timeOuts['min-chars-for-autocomplete'] = setTimeout(() => {
                        el.get(0).setCustomValidity('Please enter at least ' + t.minlength + ' characters for auto completion');
                        el.get(0).attributes.minlength = t.minlength;
                        el.get(0).reportValidity();
                        setTimeout(() => {
                            o._clearMinlengthRequirement(el);
                        }, 5000);
                    }, 2000);
                    return false;
                }

                return true;
            },

            "_clearMinlengthRequirement": function(el) {
                const o = this;
                clearTimeout(o.options.timeOuts['min-chars-for-autocomplete']);
                el.get(0).setCustomValidity('');
                el.get(0).attributes.minlength = "";
                el.get(0).reportValidity();
            },

			/*
			 * Vetology.AutoComplete._findObjectsByLabel
			 *
			 * @description	updates a field with the given conditions
			 *
			 * @return NULL
			 *
			 */
			"_findObjectsByLabel": function(i, def, el){
				var o = this;
				$.ajax(
					{
						type: 'GET',
						url: '/autocomplete',
						data: {
							"value": el.val(),
							"label": el.data("label"),
							"id": el.data("id"),
							"type": "object_id",
							"object": el.data("object"),
						},
						dataType: 'JSON',
						success: function (data){
							o._keyValueRenderResults(el, el.val(), data);
						}
					}
				);
			},
			/*
			 * Vetology.AutoComplete._objectSearch
			 *
			 * @description	updates a field with the given conditions
			 *
			 * @return NULL
			 *
			 */
			"_objectSearch": function(i, def, el){
				$.ajax(
					{
						type: 'GET',
						url: '/autocomplete',
						data: {
							"value": el.val(),
							"p": el.data("parent"),
							"type": "object"
						},
						dataType: 'JSON',
						success: function (data){
							var index = parseInt(el.data("index"));
                            if (index == 1) {
                                // remove any previous sub-condition (only allowing one for now)
                                var $tr = el.closest("tr");
                                $("[data-index=2]", $tr).remove();

                                var $of = el,
                                    $ofc = $(".objectFinderColumn", $tr),
                                    $io = $(".input_operator", $tr),
                                    $iv = $(".input_value", $tr);

                                if(data.relationsAmount > 0){
                                    // add sub condition

                                    var $of2 = $of.clone(),
                                        $ofc2 = $ofc.clone(),
                                        $io2 = $io.clone(),
                                        $iv2 = $iv.clone();

                                    $of2.attr("data-index", 2).children().remove();
                                    $ofc2.attr("data-index", 2).children().remove();
                                    $io2.attr("data-index", 2).val(0);
                                    $iv2.attr("data-index", 2).val("");

                                    // add sub-object
                                    $("<option selected='selected'>Select an option to add to the condition above (optional)</option>").appendTo($of2);
                                    $.each(data.relations, function(i, r){
                                        $of2.append('<option value="' + i + '">' + r + '</option>');
                                    });
                                    $of.after($of2);
                                    $ofc.after($ofc2);
                                    $io.after($io2);
                                    $iv.after($iv2);
                                }
                            }

							var cols = el.closest(".objectFinder_block").find(el.data("index") == 1 ? ".objectFinderColumn[data-index=1]" : ".objectFinderColumn[data-index=2]");
							cols.html("");
							$.each(data.columns, function(colName, ctrlType){
								cols.append('<option value="' + colName + '" data-ctrltype=' + ctrlType + '>' + colName + '</option>');
							});
							cols.trigger('change');
						}
					}
				);
			},
			/*
			 * Vetology.AutoComplete._blur
			 *
			 * @description	updates a field with the given conditions
			 *
			 * @return NULL
			 *
			 */
			"_blur": function(el){
				var ul = el.closest("ul.typeahead");
				ul.animate(
					{
						"opacity":0
					},
					{
						"complete": function(){
							ul.remove();
						}
					}
				);
			},
			/*
			 * Vetology.AutoComplete._keyup
			 *
			 * @description	updates a field with the given conditions
			 *
			 * @return NULL
			 *
			 */
			"_keyup": function(i, t, el){
				var o = this;
				clearTimeout(o.options.timeOuts[t.alias]);
                o._clearMinlengthRequirement(el);
				if(!el.hasClass("typeahead_input")){
					el.parent().addClass("typeahead_input_block");
					el.after('<span class="typeahead_input_block_wrap"></span>');
					var b = el.next(".typeahead_input_block_wrap");
					el.appendTo(b);//.focus();
                    setTimeout(function(el) {
                        el.focus();
                        var tmpStr = el.val();
                        el.val('');
                        el.val(tmpStr);
                    }, 10, el);
				}
				el.addClass("typeahead_input");
				if(typeof el.data("manualac") !== "undefined"){
					return;
				}
				var val = el.val();
				o.options.timeOuts[t.alias] = setTimeout(
					function(){
                        if (typeof val !== 'string') {
                            return;
                        }
                        if (!o._checkForMinChars(el, t)) {
                            return;
                        }

						o[t.function](el, val);
					},
					t.delay
				);
			},
			/*
			 * Vetology.AutoComplete._typeahead
			 *
			 * @description	updates a field with the given conditions
			 *
			 * @return NULL
			 *
			 */
			"_typeahead": function(el, p){
				var o = this;
				var val = el.data("value");
				if(typeof el.data("object") != "undefined"){
					o._updateField(val, el.data("object"), p);
				} else {
					if(typeof p.data("widget") !== "undefined"){
						var widget = p.data("widget");
						var method = p.data("method");
                        if (widget == 'Worklist') {
							// special case for worklist
							let customElement = null;
							if (method == 'newCaseSelect') {
								customElement = document.body.querySelector('main-header');
							} else {
								customElement = document.body.querySelector('work-list');
							}
                            return customElement[method](val);
                        }
						return $("body")[widget](method, val);
					}
					if(el.closest("div").hasClass("object_holder")){
						el.closest("div").find("input.object_id_finder").val("");
						el.closest("div").find(".object_label").remove();
						el.closest("div").find("input.value_holder").val(el.data("value")).before('<span class="label label-info object_label">' + el.data("label") + '</span>');
						return;
					}
					if(el.closest("div").hasClass("tag_holder")){
						var fieldName = el.closest("div").find("input.typeahead_input").attr("name");
						var current = el.closest("div").find('input[name="encoded_' + fieldName + '"]').val();
						var a = [];
						try {
							a = JSON.parse(current);
						} catch(e){
							console.log(e);
							a = [];
							/*dom something with error*/
						}
						a.push(val);
						el.closest("div").find('input[name="encoded_' + fieldName + '"]').val(JSON.stringify(a));
						el.closest("div").find("input.typeahead_input").val("").focus().before('<span class="selected_tag">' + val + ' <i class="remove_tag vetology-delete" data-value="' + val + '"></i></span>');
					} else {
						el.closest("div").find("input.typeahead_input").val(val);
					}
				}
			},
			/*
			 * Vetology.AutoComplete._removeTag
			 *
			 * @description	updates a field with the given conditions
			 *
			 * @return NULL
			 *
			 */
			"_removeTag": function(el){
				var o = this;
				var find = el.data("value");
				var fieldName = el.closest("div").find("input.typeahead_input").attr("name");
				var current = el.closest("div").find('input[name="encoded_' + fieldName + '"]').val();
				var a = [];
				try {
					a = JSON.parse(current);
				} catch(e){
					console.log(e);
					a = [];
					/*dom something with error*/
				}
				var f = [];
				$.each(a, function(i, v){
					if(v !== find){
						f.push(v);
					}
				});
				el.closest("div").find('input[name="encoded_' + fieldName + '"]').val(JSON.stringify(f));
				el.closest("span").remove();
			},
			/*
			 * Vetology.AutoComplete._updateField
			 *
			 * @description	updates a field with the given conditions
			 *
			 * @return NULL
			 *
			 */
			"_updateField": function(val, object, p){
				var o = this;
				if(typeof o.options.dataSets[object] != "undefined" && typeof o.options.dataSets[object][val] != "undefined"){
					var s = o.options.dataSets[object][val];
					if(typeof p.data("widget") !== "undefined"){
						var widget = p.data("widget");
						var method = p.data("method");
                        if (widget == 'Worklist') {
							// special case for worklist
							let customElement = null;
							if (method == 'newCaseSelect') {
								customElement = document.body.querySelector('main-header');
							} else {
								customElement = document.body.querySelector('work-list');
							}
							if (customElement == null) {
								console.error('Could not find custom element for widget: ' + widget);
								return;
							}
							return customElement[method](s);
                       }
						return $("body")[widget](method, s);
					}
					switch(object){
						case "patients":
							o.updatePatientFields(s);
							break;
						default:
							/*Update for other types of responses;*/
						break;
					}
				}
			},

			"updatePatientFields": function (s)
			{
				$('[name="ClinicPatientID"]').val(s.ClinicPatientID);
				if (s.Breed != null) {
					$('[name="Breed"]').val(s.Breed);
				} else {
					$('[name="Breed"]').val("");
				}

				this.updatePatientFieldsPatientData(s);

				if (s.RespPersonEmail != null && s.RespPersonEmail != "0") {
					$('[name="RespPersonEmail"]').val(s.RespPersonEmail);
				} else {
					$('[name="RespPersonEmail"]').val("");
				}
				if (s.RespPersonFirst != null) {
					$('[name="RespPersonFirst"]').val(s.RespPersonFirst);
				} else {
					$('[name="RespPersonFirst"]').val("");
				}
				if (s.RespPersonLast != null) {
					$('[name="RespPersonLast"]').val(s.RespPersonLast);
				} else {
					$('[name="RespPersonLast"]').val("");
				}
				if (s.country_code_RespPersonPhone != null) {
					$('[name="country_code_RespPersonPhone"]').val(s.country_code_RespPersonPhone);
				} else {
					$('[name="country_code_RespPersonPhone"]').val("");
				}
				if (s.RespPersonPhone != null) {
					$('[name="RespPersonPhone"]').val(s.RespPersonPhone);
				} else {
					$('[name="RespPersonPhone"]').val("");
				}
				if (s.country_code_RespPersonCell != null) {
					$('[name="country_code_RespPersonCell"]').val(s.country_code_RespPersonCell);
				} else {
					$('[name="country_code_RespPersonCell"]').val("");
				}
				if (s.RespPersonCell != null) {
					$('[name="RespPersonCell"]').val(s.RespPersonCell);
				} else {
					$('[name="RespPersonCell"]').val("");
				}
				var species = $('[name="Species"]').find('option:contains(' + s.Species + ')').val();
				$('[name="Species"]').val(species);
				var sex = $('[name="Sex"]').find('option:contains(' + s.Sex + ')').val();
				$('[name="Sex"]').val(sex);
				var sex = $('[name="gender"]').find('option:contains(' + s.Sex + ')').val();
				$('[name="gender"]').val(sex);
				if (s.country_code_RespOrgPhone != null) {
					$('[name="country_code_RespOrgPhone"]').val(s.country_code_RespOrgPhone);
				} else {
					$('[name="country_code_RespOrgPhone"]').val("");
				}
				if (s.RespOrgPhone != null) {
					$('[name="RespOrgPhone"]').val(s.RespOrgPhone);
				} else {
					$('[name="RespOrgPhone"]').val("");
				}
				if (s.RespOrgEmail != null && s.RespOrgEmail != "0") {
					$('[name="RespOrgEmail"]').val(s.RespOrgEmail);
				} else {
					$('[name="RespOrgEmail"]').val("");
				}
	
			},

			"updatePatientFieldsPatientData": function(s) {
				if(s.FirstName != null) {
					$('[name="ClinicID"]').val(s.ClinicID);
					$('[name="Clinic"]').val(s.ClinicID);
				} else {
					$('[name="ClinicID"]').val("");
					$('[name="Clinic"]').val("");
				}
				if (s.FirstName != null) {
					$('[name="FirstName"]').val(s.FirstName);
				} else {
					$('[name="FirstName"]').val("");
				}
				if (s.birth != null && s.birth != '') {
					var d = moment(s.birth, "MM/DD/YYYY");
					$('[name="DOB"]').val(d.format('MM/DD/YYYY'));
				} else {
					$('[name="DOB"]').val("");
				}
				if (s.LastName != null) {
					$('[name="LastName"]').val(s.LastName);
				} else {
					$('[name="LastName"]').val("");
				}
			},

			/*
			 * Vetology.AutoComplete.findPatients
			 *
			 * @description	gets a list of conditions
			 *
			 * @return NULL
			 *
			 */
			"findPatients": function(el, keyword, fn, ln){
				var o = this;
				el.attr("autocomplete", "off");
				if(typeof o.options.data_renderer == "undefined"){
					o.options.data_renderer = function (match, patient) {
						return o.renderPatient(match, patient)
					}
				}
				var keyword = el.val();
				o.options.data_provider = 'PatientID';
				o.options.data_object = 'patients';
				var field = $('[name="PatientID"]');
				var pid = '';
				if(field.length > 0){
					pid = field.val();
				}
				/*o.options.searches.push(keyword);*/
				var parent = el.parent();
				parent.addClass("typeahead_input_searching");
				$.ajax(
					{
						type: 'GET',
						url: '/autocomplete',
						data: {
							"keyword": keyword,
							"pid": pid,
							"fn": fn,
							"ln": ln,
							"type": "patients"
						},
						dataType: 'JSON',
						success: function (data){
							parent.removeClass("typeahead_input_searching");
							o.options.order_by = el.attr("name");
							o.options.dataSets.patients = {};
							$.each(data, function(i, patient){
								if(typeof o.options.dataSets.patients[patient.PatientID] == "undefined"){
									if(typeof patient.ClinicPatientID != "string"){
										patient.ClinicPatientID = patient.DICOMPatientID;
									}
									if(typeof patient.DICOMPatientID != "string"){
										patient.DICOMPatientID = patient.ClinicPatientID;
									}
									o.options.dataSets.patients[patient.PatientID] = patient;
								}
							});
							o._renderResults(el, keyword, o.options.dataSets.patients);
						}
					}
				);
			},
			"renderPatient": function (match, patient) {
				var r = '<ul>';
				r += '<li>Clinic: ' + patient.ClinicName + '</li>';
				r += '<li>Patient ID: ' + match + '</li>';
				if (patient.FirstName != null) {
					r += '<li>First name: ' + patient.FirstName + '</li>';
				}
				if (patient.LastName != null) {
					r += '<li>Last name: ' + patient.LastName + '</li>';
				}
				if (patient.Breed != null) {
					r += '<li>Breed: ' + patient.Breed + '</li>';
				}
				if (patient.Species != null) {
					r += '<li>Species: ' + patient.Species + '</li>';
				}
				if (patient.Sex != null) {
					r += '<li>Sex: ' + patient.Sex + '</li>';
				}
				var respPerson = '';
				if (patient.RespPersonFirst != null) {
					respPerson += patient.RespPersonFirst + " ";
				}
				if (patient.RespPersonLast != null) {
					respPerson += patient.RespPersonLast + " ";
				}
				respPerson = respPerson.trim();
				if (respPerson.length > 0) {
					r += "<li>Responsible person: " + respPerson + '</li>';;
				}
				respPerson = "";
				if (patient.RespPersonPhone != null) {
					respPerson = patient.RespPersonPhone + " ";
				}
				respPerson = respPerson.trim();
				if (respPerson.length > 0) {
					r += "<li>Responsible person Phone: " + respPerson + '</li>';;
				}
				r += '</ul>';
				return r;
			},

			/*
			 * Vetology.AutoComplete._findConditions
			 *
			 * @description	gets a list of conditions
			 *
			 * @return NULL
			 *
			 */
			"_findConditions": function(el, keyword){
				var o = this;
				el.attr("autocomplete", "off");
				var species = $('[name="Species"]').val();
				if(species == ''){
					species = 'base';
				}
				if(typeof o.options.dataSets.conditions == "undefined"){
					o.options.dataSets.conditions = {}
				}
				if(typeof o.options.dataSets.conditions[species] == "undefined"){
					$.ajax(
						{
							type: 'GET',
							url: '/autocomplete',
							data: {
								"keyword": species,
								"type": "conditions"
							},
							dataType: 'JSON',
							success: function (data){
								o.options.dataSets.conditions[species] = data;
								o._renderResults(el, keyword, data);
							}
						}
					);
				} else {
					o._renderResults(el, keyword, o.options.dataSets.conditions[species]);
				}
			},
			/*
			 * Vetology.AutoComplete._findBreed
			 *
			 * @description	gets a list of breeds
			 *
			 * @return NULL
			 *
			 */
			"_findBreed": function(el, keyword){
			    if (keyword.length < 3) {
			        // need to have at least 3 chars for autocomplete to kick in
			        return;
                }

                // bail if input no longer has focus
                if (!$("input[name='Breed']").is(":focus")) {
                    return;
                }

				var o = this;
				el.attr("autocomplete", "off");
				if(typeof o.options.dataSets.breeds == "undefined"){
					$.ajax(
						{
							type: 'GET',
							url: '/autocomplete',
							data: {
								"keyword": keyword,
								"type": "breeds"
							},
							dataType: 'JSON',
							success: function (data){
								o.options.dataSets.breeds = data;
								o._renderResults(el, keyword, data);
                                o._addOtherToBreedResults(keyword);
							}
						}
					);
				} else {
					o._renderResults(el, keyword, o.options.dataSets.breeds);
					o._addOtherToBreedResults(keyword);
				}
			},
            /**
             * Vetology.AutoComplete._addOtherToBreedResults
             *
             * Adds 'Other' option to results for user
             *
             * @return null
             */
            _addOtherToBreedResults: function(keyword) {
                let $results = $("ul.typeahead.dropdown-menu");
                let $other = $("<li><a class='dropdown-item vetology_pd' data-value='Other' href='#' role='option'>Other</a></li>");
                // check if specified word is in the list
                let $found = $("span:contains(" + keyword + ")", $results).first().closest("li");
                if (!$found.length) {
                    // highlighted not found, find 'close' button
                    $found = $("a.close_typeahead", $results).closest("li");
                }
                // insert 'Other' after found item
                $found.after($other);
            },
			/*
			 * Vetology.AutoComplete._keyValueRenderResults
			 *
			 * @description	Show the results for the given field
			 *
			 * @return NULL
			 *
			 */
			"_keyValueRenderResults": function(el, keyword, results){
				var o = this;
				results = o._sortResultsByKeywordKeyValue(keyword, results);
				var re = new RegExp(keyword, 'gi');
				var html = '<ul class="typeahead dropdown-menu" role="listbox">';
				html += '<li><a href="#" class="vetology_pd close_typeahead">Close</a></li>';
				if(results.length > 0){
					$.each(results, function(i, r){
						html += '<li><a class="dropdown-item vetology_pd" data-value="' + r.value + '" data-label="' + r.label + '" href="#" role="option">' + r.label.replace(re, function(match){return '<span class="highlight">' + match + '</span>'}) + '</a></li>';
					});
				}
				html += '</ul>';
				el.closest("div").find(".typeahead").remove();
				el.closest("div").append(html);
			},
			/*
			 * Vetology.AutoComplete._renderResults
			 *
			 * @description	Show the results for the given field
			 *
			 * @return NULL
			 *
			 */
			"_renderResults": function(el, keyword, results){
				var o = this;
				results = o._sortResultsByKeyword(keyword, results);
				var re = new RegExp(keyword, 'gi');
				var html = '<ul class="typeahead dropdown-menu" role="listbox">';
				html += '<li><a href="#" class="vetology_pd close_typeahead">Close</a></li>';
				if(results.length > 0){
					$.each(results, function(i, result){
						if(typeof result != "string"){
							if(typeof o.options.data_renderer != "undefined"){
								html += '<li><a data-object="' + o.options.data_object + '" class="dropdown-item vetology_pd" data-value="' + result[o.options.data_provider] + '" href="#" role="option">';
								html += o.options.data_renderer(result[o.options.order_by].replace(re, function(match){return '<span class="highlight">' + match + '</span>'}), result);
								html += '</a></li>';
							} else {
								html += '<li><a data-object="' + o.options.data_object + '" class="dropdown-item vetology_pd" data-value="' + result[o.options.data_provider] + '" href="#" role="option">' + result[o.options.order_by].replace(re, function(match){return '<span class="highlight">' + match + '</span>'}) + '</a></li>';
							}
						} else {
                            html += '<li><a class="dropdown-item vetology_pd" data-value="' + result + '" href="#" role="option">' + result.replace(keyword, function(match){return '<span class="highlight">' + match + '</span>'}) + '</a></li>';
                        }
					});
				}
				html += '<li><a class="dropdown-item vetology_pd" data-value="' + keyword + '" href="#" role="option">What I am looking for is not on the list.<br>Select <span class="highlight">' + keyword + '</span></a></li>';
				html += '</ul>';
				el.closest("div").find(".typeahead").remove();
				el.closest("div").append(html);
			},
			/*
			 * Vetology.AutoComplete._sortResultsByKeyword
			 *
			 * @description	Sorts the results using a keyword
			 *
			 * @return NULL
			 *
			 */
			"_sortResultsByKeyword": function(keyword, results){
				var o = this;
				var start = 0;
				var max = 0;
				keyword = keyword.toLowerCase();
				$.each(results, function(i, r){
					if(typeof r == "object"){
                        r[o.options.order_by] = r[o.options.order_by] === null ? '' : r[o.options.order_by];
                        max = r[o.options.order_by].length > max ? r[o.options.order_by].length : max;
					} else {
						max = r.length > max ? r.length : max;
					}
				});
				var length = keyword.length;
				var ordered = [];
				var added = [];
				var p;
				while(ordered.length != results.length){
					$.each(results, function(i, r){
						if($.inArray(i, added) ===-1){
							if(typeof r == "object"){
								p = r[o.options.order_by].substring(start, (start + length)).toLowerCase();
							} else {
								p = r.substring(start, (start + length)).toLowerCase();
							}
							if(p == keyword || r.isExactMatch){
								ordered.push(r);
								added.push(i);
							}
						}
					});
					start ++;
					if(start > max){
						break;
					}
				}
				return ordered;
			},
			/*
			 * Vetology.AutoComplete._sortResultsByKeywordKeyValue
			 *
			 * @description	Sorts the results using a keyword
			 *
			 * @return NULL
			 *
			 */
			"_sortResultsByKeywordKeyValue": function(keyword, results){
				var o = this;
				var start = 0;
				var max = 0;
				keyword = keyword.toLowerCase();
				$.each(results, function(i, r){
					max = r.label.length > max ? r.label.length : max;
				});
				var length = keyword.length;
				var ordered = [];
				var added = [];
				var p;
				while(ordered.length != results.length){
					$.each(results, function(i, r){
						if($.inArray(i, added) ===-1){
							p = r.label.substring(start, (start + length)).toLowerCase();
							if(p == keyword){
								ordered.push(r);
								added.push(i);
							}
						}
					});
					start ++;
					if(start > max){
						break;
					}
				}
				return ordered;
			},

            "_findNothing": function(el, keyword) {
			    // temp dummy function, to bypass autocomplete
            }
		}
	);
})(jQuery);

